const DEFAULT_DATA = {
    id: null,
    code: null,
    description: null
}

const CLEAR_PRODUCT_INPUTS = 'CLEAR_PRODUCT_INPUTS'

export function ncmReducer(state = "", action) {
    switch (action.type) {
        case "SET_NCM":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return DEFAULT_DATA
        default:
            return state
    }
}

export function cestReducer(state = DEFAULT_DATA, action) {
    switch (action.type) {
        case "SET_CEST":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return DEFAULT_DATA
        default:
            return state
    }
}
export function cfopReducer(state = DEFAULT_DATA, action) {
    switch (action.type) {
        case "SET_CFOP":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return DEFAULT_DATA
        default:
            return state
    }
}

export function icmsReducer(state = DEFAULT_DATA, action) {
    switch (action.type) {
        case "SET_ICMS":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return {}
        default:
            return state
    }
}
export function ncmDataReducer(state = null, action) {
    switch (action.type) {
        case "SET_NCM_DATA":
            return action.payload
        default:
            return state
    }
}
export function cestDataReducer(state = null, action) {
    switch (action.type) {
        case "SET_CEST_DATA":
            return action.payload
        default:
            return state
    }
}

export function cfopDataReducer(state = {}, action) {
    switch (action.type) {
        case "SET_CFOP_DATA":
            return action.payload
        default:
            return state
    }
}
export function icmsDataReducer(state = {}, action) {
    switch (action.type) {
        case "SET_ICMS_DATA":
            return action.payload
        default:
            return state
    }
}

export function ipiDataReducer(state = {}, action) {
    switch (action.type) {
        case "SET_IPI_DATA":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return {}
        default:
            return state
    }
}

export function pisDataReducer(state = {}, action) {
    switch (action.type) {
        case "SET_PIS_DATA":
            return action.payload
        case CLEAR_PRODUCT_INPUTS:
            return {}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/reducers.js